"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animates = animates;
exports.getWinScrollY = exports.fomateFileData = void 0;
exports.reinitIframe = reinitIframe;
exports.scaleAnimation = void 0;
exports.throttle = throttle;
exports.windowAddEventListener = windowAddEventListener;
exports.windowRemoveEventListener = windowRemoveEventListener;
// task perform  queue
var queuePerformTask = new WeakMap();

function init_compute(callback) {
  var _w = window.innerWidth;

  if (_w > 768) {
    callback(true, _w);
  } else {
    callback(false, _w);
  }
}

function windowAddEventListener(callback, delay) {
  if (!queuePerformTask.get(callback)) {
    queuePerformTask.set(callback, callback);
  }

  init_compute(callback); // console.log(queuePerformTask, 'queuePerformTask')

  window.addEventListener('resize', throttle(function () {
    init_compute(callback);
  }, delay || 1000));
}

function throttle(callback, delay) {
  var timeout = null;
  return function () {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null; // eslint-disable-next-line @typescript-eslint/prefer-optional-chain

      callback && callback();
    }, delay || 3000);
  };
}

function windowRemoveEventListener() {
  window.removeEventListener('resize', throttle);
}

function animates(ball, targetX, targetY) {
  var easing = 0.2; // if (ball.x > 295) {
  //     debugger;
  // }

  ball.x += (targetX - ball.x) * easing;
  ball.y += (targetY - ball.y) * easing;
  return {
    x: ball.x,
    y: ball.y,
    targetX: targetX
  };
}

var nowDate = new Date().getTime();
/*
 * 资源文件处理，alt
 */

var fomateFileData = function fomateFileData(val) {
  try {
    var data = JSON.parse(val);
    return data;
  } catch (err) {
    return {
      url: val,
      alt: ''
    };
  }
};
/*
 * VOD视频上传数据处理
 */


exports.fomateFileData = fomateFileData;

var fomateVodData = function fomateVodData(val) {
  try {
    var data = JSON.parse(val);
    return data;
  } catch (err) {
    return {
      url: val
    };
  }
};

function reinitIframe(props) {
  // console.log(props, 'import');
  var _a = props || {},
      filedVideoBg = _a.filedVideoBg,
      filedVideoList = _a.filedVideoList,
      postMessageUrl = _a.postMessageUrl;

  var iframe = document.getElementById('frame_child_content');

  var _b = fomateVodData(filedVideoList),
      url = _b.url,
      id = _b.id;

  var filedVideoBgUrl = fomateFileData(filedVideoBg).url;

  function requestAnimationRequestFunc() {
    if (new Date().getTime() - nowDate >= 2000) {
      iframe.contentWindow.postMessage({
        status: '1',
        filedVideoBg: filedVideoBgUrl,
        filedVideoList: id || url
      }, postMessageUrl || 'https://intl.cloud.tencent.com/solution-new/tcp-player'); // 父向子传递

      window.addEventListener('message', function (event) {
        // 父获取子传递的消息
        // console.log("%c收到children", "font-size:100px;");
        var iframe = document.getElementById('frame_child_content');

        if (event.data === '1') {
          // @ts-ignore
          iframe.style.display = 'none';
        }
      }, false);
    } else {
      requestAnimationRequestFunc();
    }
  }

  requestAnimationRequestFunc();

  try {
    // var bHeight = iframe.contentWindow.document.body.scrollHeight,
    // 	dHeight = iframe.contentWindow.document.documentElement.scrollHeight,
    // 	height = Math.max(bHeight, dHeight);
    // console.log(height)
    // @ts-ignore
    iframe.width = '100%'; // @ts-ignore

    iframe.height = '100%'; // @ts-ignore

    iframe.style.display = 'block';
  } catch (ex) {}
} // intl tools


var getWinScrollY = function getWinScrollY() {
  return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
}; // //Conflict at the same level
// export function conflict(index?:any,event?:any) {
//   let pre_event: any;
//   return () => {
//     if (!event) return;
//     const val = event.target;
//     if (!pre_event) {
//       pre_event = val;
//     }
//     if (right_ref.current) {
//       pre_event.className = 'scene-tabs-description';
//       const _right_ref_ = right_ref.current.childNodes[index % listMapLen] as any;
//       _right_ref_.style.display = 'none';
//     }
//
//     if (useRefLi.current && right_ref.current) {
//       val.className = 'scene-tabs-description scene-tabs-h4--active';
//       const _right_ref_ = right_ref.current.childNodes[index % listMapLen] as any;
//       _right_ref_.style.className = 'scene-tabs-container-right__section ';
//       _right_ref_.style.display = 'block';
//     }
//     pre_event = val;
//   }()
// }


exports.getWinScrollY = getWinScrollY;

var scaleAnimation = function scaleAnimation(str) {
  var schd = document.querySelector("#" + str); // const windowWidth = schd.parentNode ? schd.parentNode.clientWidth : 0;

  var windowWidth = window.innerWidth;
  var domeWidthValue = 768;
  var scale = 1;

  if (windowWidth < domeWidthValue) {
    scale = 375 / domeWidthValue;
  } else {
    scale = windowWidth / domeWidthValue > 1 ? 1 : windowWidth / domeWidthValue;
  } // @ts-ignore


  schd.style.transform = "scale(" + scale + ") translate(-50%, -50%)";
};

exports.scaleAnimation = scaleAnimation;